<template>
  <div class="w-full overflow-hidden rounded-lg border bg-white text-left animate-pulse">
    <div class="grid grid-cols-12 items-center gap-6 px-6 py-4">
      <div class="col-span-3 flex flex-col gap-2">
        <div class="h-4 bg-slate-200 rounded w-3/4"></div>
        <div class="h-4 bg-slate-200 rounded w-2/3"></div>
      </div>

      <div class="col-span-6 text-center flex flex-col items-center gap-2">
        <div class="flex justify-around w-full px-4">
          <div class="h-3 bg-slate-200 rounded w-16"></div>
          <div class="h-3 bg-slate-200 rounded w-16"></div>
        </div>
        <div class="h-10 w-full bg-slate-200 rounded-md"></div>
      </div>

      <div class="col-span-2 flex flex-col gap-2">
        <div class="h-3 bg-slate-200 rounded w-1/2"></div>
        <div class="h-4 bg-slate-200 rounded w-full"></div>
        <div class="h-3 bg-slate-200 rounded w-3/4"></div>
      </div>

      <div class="col-span-1 flex justify-end">
        <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
